document.addEventListener('page:loaded', function() {
  	var addBundleButton = document.getElementById('add-bundle');

  	if (!addBundleButton) {
  		return;
  	}

  	addBundleButton.addEventListener('click', function(evt) {
		addBundleButton.classList.add('btn--loading');
      	var mode = document.getElementById("mode").value;
      	var items = [];
      
        if(mode == "both"){
          
          	var pr_top = document.querySelector("input[name='pr_top']").value;
          	var pr_bottom = document.querySelector("input[name='pr_bottom']").value;
          
            items.push({id: pr_top, quantity: 1});
            items.push({id: pr_bottom, quantity: 1});

        } else if(mode == "top"){
        	var pr_top = document.querySelector("input[name='pr_top']").value;
          	items.push({id: pr_top, quantity: 1});
        } else {
        	var pr_bottom = document.querySelector("input[name='pr_bottom']").value;
          	items.push({id: pr_bottom, quantity: 1});
        }
      
      	fetch('/cart/add.js', {
          method: 'POST',
          body: JSON.stringify({
            'items': items
          }),
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(response => response.json())
        .then(function(data) {
          addBundleButton.classList.remove('btn--loading');

          if (data.status === 422) {
            console.log("err", data);
          } else {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: {
                product: data,
                addToCartBtn: ""
              }
            }));
          }
        })
        .catch(function(err) {
          console.log("err", err);
          addBundleButton.classList.remove('btn--loading');
        });
      
    }, false);
  
  	document.querySelectorAll('.button-bundle').forEach(btn => {
      btn.addEventListener('click', triggerButton);
    });
  
  	var show = function (selector) {
      	var elem = document.getElementById(selector);
		elem.style.display = 'block';
    };

    // Hide an element
    var hide = function (selector) {
      	var elem = document.getElementById(selector);
        elem.style.display = 'none';
    };
  
    function triggerButton(evt) {
      	var mode = evt.currentTarget.dataset.mode;
        document.querySelectorAll('.button-bundle').forEach(el => {
          el.classList.remove('button-bundle-active');
        });
      
      	evt.currentTarget.classList.add('button-bundle-active');
      	
        if(mode == 'top'){
			hide('bundle-bottom');
          	show('bundle-top');
        } else if (mode == 'bottom'){
        	hide('bundle-top');
          	show('bundle-bottom');
        } else {
        	// AMBOS (tab comentado; se conserva por si se reactiva)
        	show('bundle-bottom');
          	show('bundle-top');
        }
      
      	document.getElementById("mode").value = mode;
    }
  
  	var radios = document.querySelectorAll('input[data-variant-input]');
  	radios.forEach(radio => radio.addEventListener('change', () => {
    	var productId = radio.dataset.product;
		var variantId = radio.dataset.variant;                                               	
		
		document.getElementById(productId).value = variantId;
      	
        if(radio.disabled){
			addBundleButton.disabled = true;
        } else {
        	addBundleButton.disabled = false;
        }
      	
	}));
});
